import React from 'react';
import { Route, Routes, Navigate, useMatch } from 'react-router-dom';
import RequireAuth from 'components/RequireAuth';

import FreightSearch from './FreightSearch';
import ScrollToTopOnMount from '@/ScrollToTop';
import AddFreight from './AddFreight';
import EditFreight from './EditFreight';
import TemplateMap from './TemplateMap';
import PageContainer from 'components/common/PageContainer';
import { FREIGHTS_RELATIVE_ROUTES, FREIGHTS } from 'helpers/routes';
import { CARGO } from 'endpointsConst';

import 'components/PublicTableElements/table.scss';

const Freight: React.FC = () => {
  const isMapPage = useMatch('/freight/map/:templateId');

  // Render fullscreen map page without PageContainer
  if (isMapPage) {
    return <TemplateMap templateId={isMapPage.params.templateId} />;
  }

  return (
    <>
      <ScrollToTopOnMount />
      <PageContainer>
        <Routes>
          <Route index element={<Navigate to={FREIGHTS.search} replace />} />
          <Route path={FREIGHTS_RELATIVE_ROUTES.search} element={<FreightSearch />} />
          <Route
            path={FREIGHTS_RELATIVE_ROUTES.add}
            element={<RequireAuth><AddFreight urlToCreate={`${CARGO}/exchange`} urlToRedirect={`${FREIGHTS.search}?status=active`} mode="freight" /></RequireAuth>}
          />
          <Route path={FREIGHTS_RELATIVE_ROUTES.edit} element={<RequireAuth><EditFreight /></RequireAuth>} />
        </Routes>
      </PageContainer>
    </>
  );
};

export default Freight;
